import { Node } from 'reactflow';
import { Button } from "@/shared/components/ui/button";
import { JsonViewer } from "@/shared/components/ui/json-viewer";
import { toast } from "@/shared/components/ui/use-toast";
import { Copy, Check } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/shared/components/ui/tooltip";
import { useTranslation } from 'react-i18next';

interface NodeInputProps {
  node: Node | null;
   // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inputData: any;
}

export function NodeInput({ node: _node, inputData }: NodeInputProps) {
  const { t } = useTranslation();

  return (
    <div className="w-[350px] border-r pr-4 flex flex-col min-h-0">
      <div className="flex items-center justify-between mb-2 flex-shrink-0">
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-medium">
            {t('agents.workflow.input')}
          </h3>
          {inputData && Object.keys(inputData).length > 0 && (
            <Check className="w-4 h-4 text-emerald-500" />
          )}
        </div>
        {inputData && Object.keys(inputData).length > 0 && (
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                className="h-8 w-8"
                onClick={() => {
                  navigator.clipboard.writeText(
                    JSON.stringify(inputData, null, 2)
                  );
                  toast({
                    title: t('common.success'),
                    description: t('common.copied'),
                    duration: 2000,
                  });
                }}
              >
                <Copy className="h-4 w-4" />
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <p>{t('common.copy')}</p>
            </TooltipContent>
          </Tooltip>
        )}
      </div>
      <div className="flex-1 overflow-y-auto">
        {inputData && Object.keys(inputData).length > 0 ? (
          <div className="bg-emerald-50 rounded-md">
            <JsonViewer 
              data={inputData} 
              style={{
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                fontSize: '0.875rem',
                overflowWrap: 'break-word'
              }}
            />
          </div>
        ) : (
          <div className="h-full flex flex-col items-center justify-center text-sm text-muted-foreground border rounded-md bg-muted/50 p-4">
            <span className="font-medium">{t('agents.workflow.noInputTitle')}</span>
            <span className="text-center mt-1">{t('agents.workflow.noInputDesc')}</span>
          </div>
        )}
      </div>
    </div>
  );
}
